<template>
  <v-dialog
    :value="true"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="slide-y-reverse-transition"
    max-width="800"
    scrollable
    persistent
  >
    <UserForm
      :user="newUser"
      :errors="userValidationErrors"
      :disabled="savingUser"
      @clear:errors="clearUserValidationErrors"
      @cancel="$router.push({ name: 'users' })"
      @save="onSave"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import UserForm from '../../components/UserForm';

export default {
  name: 'CreateUser',

  components: { UserForm },

  computed: mapState('users', ['newUser', 'userValidationErrors', 'savingUser']),

  methods: {
    ...mapActions('users', ['storeUser', 'clearUserValidationErrors']),

    onSave(user) {
      this.storeUser(user).then(() => {
        this.$router.push({ name: 'users' });
      });
    },
  },
};
</script>
